<template>
  <div class="h-full">
    <!-- 1st Row -->
    <div class="d-flex align-center px-sm-6 px-4 py-2">
      <!-- Back Button -->
      <v-btn icon small class="me-2" @click="$emit('close')">
        <v-icon size="28">
          {{ icons.mdiChevronLeft }}
        </v-icon>
      </v-btn>
      <!-- Subject -->
    </div>

    <v-divider></v-divider>
    <div class="px-sm-6 px-4 py-2" style="background-color: rgba(94, 86, 105, 0.04)">
      <v-stepper flat elevation="0">
        <v-stepper-header>
          <v-stepper-step step="1" :complete="feedback.status > 0" color="success">
            {{ $t("Saapunut") }}
            <div class="mt-1">
              {{ getDate(feedback.insert_date) }}
            </div>

            <template>

            </template>
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step step="2" :complete="feedback.status > 1" color="success">
            {{ $t("Otettu käsittelyyn") }}
            <div class="mt-1" v-if="feedback.status > 1 && feedback.started_date">
              {{ getDate(feedback.started_date) }}
            </div>
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step step="3" :complete="feedback.status > 2" color="success">
            {{ $t("Valmis") }}
            <div class="mt-1" v-if="feedback.status > 2 && feedback.completed_date">
              {{ getDate(feedback.completed_date) }}
            </div>
          </v-stepper-step>
        </v-stepper-header>
      </v-stepper>
    </div>
    <perfect-scrollbar ref="psEmailViewContent" :settings="perfectScrollbarSettings" class="ps-email-view-content">
      <div class="position-relative ml-7 mr-7 mb-7 mt-3">
        <div class="mb-3"></div>
        <v-card flat>
          <div class="pa-5 d-flex flex-wrap align-center">
            <v-avatar size="38" class="me-3" color="primary">
              <v-icon color="white" size="24">
                {{ icons.mdiAccountOutline }}
              </v-icon>
            </v-avatar>
            <div class="d-flex justify-center flex-column">
              <span class="text--primary font-weight-medium text-base">
                {{ $t("Palaute") }}
              </span>
              <span>
                {{ getDate(feedback.insert_date) }}
              </span>
            </div>
          </div>
          <div class="px-3 pb-3">
            <v-divider></v-divider>
          </div>
          <v-card-text v-if="feedback.feedback" style="white-space: pre-line">
            {{ feedback.feedback }}
          </v-card-text>

          <template v-if="feedback.form_submission">
            <FormSubmissionRenderer :responses="feedback.form_submission.responses" />
          </template>
          <v-card-actions v-if="feedback.category">
            <v-chip>{{ feedback.category }}</v-chip>
          </v-card-actions>
        </v-card>

        <template v-if="feedback.attachment_name || feedback.attachments.length">
          <br>
          <v-card flat>
            <div class="pa-5 d-flex flex-wrap align-center">
              <v-avatar size="38" class="me-3" color="primary">
                <v-icon color="white" size="24">
                  {{ icons.mdiAttachment }}
                </v-icon>
              </v-avatar>
              <div class="d-flex justify-center flex-column">
                <span class="text--primary font-weight-medium text-base">
                  {{ $t("Liitteet") }}
                </span>
              </div>
            </div>
            <v-card-text>
              <v-list single-line>
                <v-list-item @click="openLegacyAttachment" v-if="feedback.attachment_name">
                  <v-list-item-icon>
                    <v-icon>{{ icons.mdiAttachment }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ feedback.attachment_name }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item v-for="attachment in feedback.attachments" :key="attachment.id"
                  @click="openAttachment(attachment.id, attachment.name)">
                  <v-list-item-icon>
                    <v-icon>{{ icons.mdiAttachment }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ attachment.name }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-card>
        </template>

        <br />
        <v-card flat>
          <div class="pa-5 d-flex flex-wrap align-center">
            <v-avatar size="38" class="me-3" color="primary">
              <v-icon color="white" size="24">
                {{ icons.mdiReply }}
              </v-icon>
            </v-avatar>
            <div class="d-flex justify-center flex-column">
              <span class="text--primary font-weight-medium text-base">
                {{ $t("Yhteystiedot") }}
              </span>
            </div>
          </div>
          <div class="px-3 pb-3">
            <v-divider></v-divider>
          </div>
          <v-card-text>
            <div v-if="feedback.require_answer">
              <v-alert text color="info">
                {{ $t("Käyttäjä on jättänyt yhteystiedot yhteydenottoa varten") }}
              </v-alert>
              <v-btn :href="getReplyChannel()" color="secondary">
                <v-icon class="mr-2">
                  {{ getReplyChannelIcon() }}
                </v-icon>
                <span style="text-transform: none">
                  {{ feedback.answer_to }}
                </span>
              </v-btn>
            </div>
            <v-alert v-else text color="warning">
              {{ $t("Käyttäjä ei ole jättänyt yhteystietoja") }}
            </v-alert>
          </v-card-text>
        </v-card>
        <template v-if="feedback.version == 2">
          <br>
          <v-card flat>
            <div class="pa-5 d-flex flex-wrap align-center">
              <v-avatar size="38" class="me-3" color="primary">
                <v-icon color="white" size="24">
                  {{ icons.mdiChatOutline }}
                </v-icon>
              </v-avatar>
              <div class="d-flex justify-center flex-column">
                <span class="text--primary font-weight-medium text-base">
                  {{ $t("Viestit") }}
                </span>
              </div>
            </div>
            <div class="px-3 pb-3">
              <v-divider></v-divider>
            </div>
            <v-card-text>

              <v-card flat>
                <v-list>
                  <v-list-item v-for="message in feedback.messages" class="mb-6" :key="message.id">
                    <v-list-item-avatar size="28" class="me-3" color="primary"
                      v-if="message.message_type == feedbackMessageTypes.feedbackUser">
                      <v-icon size="18" color="white">{{ icons.mdiAccountOutline }}</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-avatar v-else size="28">
                      <v-img size="18" :src="tenant.logo.thumbnail"></v-img>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-subtitle>
                        <template v-if="message.message_type == feedbackMessageTypes.feedbackUser">
                          {{ $t('Käyttäjä') }}:
                        </template>
                        <template v-else>
                          {{ tenant.name }}:
                        </template>
                        {{ getDateTime(message.insert_date) }}
                        <v-divider class="my-1"></v-divider>
                      </v-list-item-subtitle>
                      <span style="white-space: pre-line;">
                        {{ message.text }}
                      </span>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
                <template v-if="feedback.status == 2">
                  <v-textarea v-model="newMessage" :label="$t('Lähetä lisäkysymys tai vastus')" outlined
                    :hint="$t('Palautteen lähettäjä voi vastata lähettämääsi viestiin tai viesteihin niin kauan, kunnes palaute on merkitty käsitellyksi.')"
                    persistent-hint>
                  </v-textarea>
                  <v-btn @click="sendMessage" color="primary" type="submit" :loading="isSubmittingMessage" small>{{
                    $t('Lähetä')
                  }}</v-btn>
                </template>
                <template v-else-if="feedback.status == 1">
                  <v-alert text type="info">
                    <span
                      v-text="$t('Voit lähettää palautteen lähettäjälle viestin tai vastauksen sen jälkeen, kun palaute on otettu käsittelyyn')"></span>
                  </v-alert>
                </template>
              </v-card>
            </v-card-text>
          </v-card>
        </template>


        <br />
        <v-card flat>
          <div class="pa-5 d-flex flex-wrap align-center">
            <v-avatar size="38" class="me-3" color="primary">
              <v-icon color="white" size="24">
                {{ icons.mdiProgressClock }}
              </v-icon>
            </v-avatar>
            <div class="d-flex justify-center flex-column">
              <span class="text--primary font-weight-medium text-base">
                {{ $t("Käsittely") }}
              </span>
            </div>
          </div>
          <div class="px-3 pb-3">
            <v-divider></v-divider>
          </div>
          <v-card-text>
            <div v-if="feedback.status == 1">
              <v-btn color="primary" small @click="start">
                {{ $t("Ota käsittelyyn") }}</v-btn>
            </div>
            <div v-if="feedback.status == 2">
              <v-textarea v-model="feedback.internal_comment" outlined :label="$t('Sisäinen lisätieto')" persistent-hint
                :hint="$t('Sisäinen lisätieto ei näy palautteen lähettäjälle')">
              </v-textarea>
              <v-btn color="primary" small @click="saveInfo">
                {{ $t("Tallenna lisätieto") }}
              </v-btn>
              <v-icon color="success" class="ml-2" v-if="infoSaved">
                {{ icons.mdiCheck }}
              </v-icon>
            </div>

            <div v-if="feedback.status == 3">
              <v-textarea outlined :label="$t('Sisäinen lisätieto')" persistent-hint readonly
                :value="feedback.internal_comment">
              </v-textarea>
            </div>
          </v-card-text>
        </v-card>
        <br />
        <v-btn v-if="feedback.status == 2" color="success" @click="finish">
          {{ $t("Kuittaa käsitellyksi") }}
        </v-btn>
      </div>
    </perfect-scrollbar>
    <v-dialog v-model="isDownloading" hide-overlay persistent width="240">
      <v-card color="primary" dark>
        <v-card-text class="pt-2">
          {{ $t("Ladataan...") }}

          <v-progress-linear indeterminate color="white" class="mb-0 mt-2"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  mdiChevronLeft,
  mdiChevronRight,
  mdiTrashCanOutline,
  mdiEmailOutline,
  mdiFolderOutline,
  mdiLabelOutline,
  mdiArrowExpandVertical,
  mdiArrowCollapseVertical,
  mdiDotsVertical,
  mdiAccountOutline,
  mdiChatOutline,
  mdiReply,
  mdiProgressClock,
  mdiMessageAlert,
  mdiPhone,
  mdiAt,
  mdiCheck,
  mdiAttachment
} from "@mdi/js";
// eslint-disable-next-line object-curly-newline
import { computed, nextTick, ref, watch } from "@vue/composition-api";
import { PerfectScrollbar } from "vue2-perfect-scrollbar";
import { psScrollToBottom, psScrollToTop } from "@core/utils";
import { getDate } from "@/@core/utils/datetime_helpers";
import api from "@/api";
import adminApi from "@/api/admin";
import { i18n } from "@/plugins/i18n";
import useAdminNotifications from "@/@core/utils/useAdminNotifications";
import download from "downloadjs";
import feedbackMessageTypes from '@/@core/utils/feedback_message_types';
import useAuth from "@/useAuth";
import { getDateTime } from "@/@core/utils//datetime_helpers";
import FormSubmissionRenderer from "@/components/forms/FormSubmissionRenderer.vue";

export default {
  components: {
    PerfectScrollbar,
    FormSubmissionRenderer,
  },
  props: ["feedback"],
  setup(props, context) {
    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelPropagation: false,
    };

    const { refreshNewFeedbackCount } = useAdminNotifications();
    const infoSaved = ref(false);
    const { tenant } = useAuth();
    const newMessage = ref('');
    const isDownloading = ref(false);

    const getReplyChannel = () => {
      if (props.feedback.require_answer && props.feedback.answer_to) {
        if (props.feedback.answer_to.indexOf("@") > -1) {
          return `mailto:${props.feedback.answer_to}`;
        }
        return `tel:${props.feedback.answer_to}`;
      }
      return "";
    };

    const getReplyChannelIcon = () => {
      if (props.feedback.require_answer && props.feedback.answer_to) {
        if (props.feedback.answer_to.indexOf("@") > -1) {
          return mdiAt;
        }
        return mdiPhone;
      }
      return null;
    };

    const start = async () => {
      if (
        confirm(i18n.t("Haluatko varmasti ottaa palautteen käsittelyyn?"))
      ) {
        const payload = JSON.parse(JSON.stringify(props.feedback));
        payload.status = 2;

        const response = await adminApi.updateFeedback(payload);
        if (response.ok) {
          props.feedback.status = 2;
          props.feedback.started_date = new Date();

          refreshNewFeedbackCount();
          context.emit('status-changed');
        } else {
          alert(response.error);
        }
      }
    };

    const saveInfo = async () => {
      const payload = JSON.parse(JSON.stringify(props.feedback));

      const response = await adminApi.updateFeedback(payload);
      if (response.ok) {
        infoSaved.value = true;
        setTimeout(() => {
          infoSaved.value = false;
        }, 3000);
      } else {
        alert(response.error);
      }
    };

    const finish = async () => {
      if (
        confirm(i18n.t("Haluatko varmasti kuitata palautteen käsittellyksi?"))
      ) {
        const payload = JSON.parse(JSON.stringify(props.feedback));
        payload.status = 3;

        const response = await adminApi.updateFeedback(payload);
        if (response.ok) {
          props.feedback.status = 3;
          context.emit('status-changed');
        } else {
          alert(response.error);
        }
      }
    };

    const openLegacyAttachment = async () => {
      isDownloading.value = true;
      const response = await adminApi.downloadLegacyFeedbackAttachment(props.feedback.id);
      isDownloading.value = false;

      if (response.ok) {
        download(response.data, props.feedback.attachment_name);
      } else {
        alert(response.error);
      }
    }

    const openAttachment = async (attachmentId, attachmentName) => {
      isDownloading.value = true;
      const response = await adminApi.downloadFeedbackAttachment(props.feedback.id, attachmentId);
      isDownloading.value = false;

      if (response.ok) {
        download(response.data, attachmentName);
      } else {
        alert(response.error);
      }
    }

    const isSubmittingMessage = ref(false);

    const sendMessage = async () => {
      if (newMessage.value.length) {
        isSubmittingMessage.value = true;

        const res = await adminApi.saveFeedbackMessage(props.feedback.id, newMessage.value);
        if (res.ok) {
          props.feedback.messages.push(res.data);
        }
        else {
          alert(res.data);
        }

        isSubmittingMessage.value = false;
        newMessage.value = "";
      }
    }

    return {
      perfectScrollbarSettings,
      getDate,
      getReplyChannel,
      getReplyChannelIcon,
      start,
      saveInfo,
      finish,
      isDownloading,
      infoSaved,
      openLegacyAttachment,
      openAttachment,
      getDateTime,
      newMessage,
      feedbackMessageTypes,
      sendMessage,
      isSubmittingMessage,
      tenant,
      icons: {
        mdiChevronLeft,
        mdiChevronRight,
        mdiTrashCanOutline,
        mdiEmailOutline,
        mdiFolderOutline,
        mdiLabelOutline,
        mdiArrowExpandVertical,
        mdiArrowCollapseVertical,
        mdiChatOutline,
        mdiDotsVertical,
        mdiAccountOutline,
        mdiReply,
        mdiCheck,
        mdiMessageAlert,
        mdiProgressClock,
        mdiAttachment
      },
    };
  },
};
</script>


<style lang="scss">
@import "~@core/preset/preset/mixins.scss";
@import "~vuetify/src/components/VCard/_variables.scss";

@include theme--child(ps-email-view-content) using ($material) {
  background-color: rgba(map-deep-get($material, "primary-shade"), 0.04);
}

.ps-email-view-content {
  height: calc(100% - 46px - 46px - 2px);

  .view-all-toggler {
    &:hover {
      color: var(--v-primary-base) !important;
    }
  }

  .email-replies-preview-container {
    .email-reply-preview {
      height: 15px;
      transform-origin: top;
      margin-left: auto;
      margin-right: auto;

      border-top-left-radius: $card-border-radius;
      border-top-right-radius: $card-border-radius;

      @at-root {
        @include theme--child(ps-email-view-content) using ($material) {
          .email-replies-preview-container {
            .email-reply-preview {
              border-left: thin solid rgba(map-deep-get($material, "primary-shade"), 0.14);
              border-right: thin solid rgba(map-deep-get($material, "primary-shade"), 0.14);
              border-top: thin solid rgba(map-deep-get($material, "primary-shade"), 0.14);
            }
          }

          background-color: rgba(map-deep-get($material, "primary-shade"),
            0.04);
        }
      }
    }
  }
}
</style>
